import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/especiais/gran-plus/page.client.tsx");
